<template>
  <div>
    <FormEditable
      v-for="(item, index) in value"
      :key="trackBy ? item[trackBy] : index"
      ref="editable"
      :disabled="disabled"
      :unsaved="unsaved"
      :dataTest="`${dataTest}${index}`"
      @close="$emit('close', item, index)"
    >
      <template #default="{ isRead, isEdit }">
        <div
          class="form-list__item mb-4 py-3"
          :class="{
            'form-list__item--edit': isEdit && !disabled,
            'form-list__item--invalid': (validation[index] || {}).$invalid,
          }"
        >
          <slot
            :isRead="isRead"
            :isEdit="isEdit"
            :item="item"
            :index="index"
            :updateItem="updateItem"
          />
        </div>
      </template>
    </FormEditable>
    <div v-if="disabled && (!value || !value.length)" class="text-muted">
      <slot name="none">
        None
      </slot>
    </div>
  </div>
</template>

<script>
import _without from 'lodash/without'
import FormEditable from './FormEditable'

export default {
  inheritAttrs: false,
  components: { FormEditable },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    trackBy: {
      type: String,
      required: false,
    },
    validation: {
      type: Object,
      default: () => ({}),
    },
    unsaved: {
      type: Boolean,
      default: false,
    },
    dataTest: {
      type: String,
      default: '',
    },
  },
  methods: {
    updateItem (index, update) {
      const rest = _without(this.value, this.value[index])
      const [ front, tail ] = [ rest.slice(0, index), rest.slice(index) ]
      this.$emit('input', [
        ...front,
        update,
        ...tail,
      ],
      update,
      index)
    },
    add (value = {}) {
      this.$emit('input', [ ...this.value, value ], value, this.value.length)
      if (!this.$refs.editable) return
      this.$nextTick(() => this.$refs.editable[this.value.length - 1].edit())
    },
  },
}
</script>

<style scoped>
  .form-list__item {
    border-left: 4px var(--gray) solid;
    background-color: rgba(0, 0, 0, 0.01);
    padding: 0 1rem;
  }
  .form-list__item--edit {
    border-color: var(--blue);
  }
  .form-list__item--invalid {
    border-color: var(--danger);
  }
  .form-list__item /deep/ form.auto-form {
    margin-bottom: 0;
  }
  .form-list__item /deep/ .form-control[disabled='disabled'] {
    background: transparent;
    padding-left: 0;
  }
</style>
